import React from "react";
import Skeleton from "../skeleton";

const Desktop = () => (
	<div className="container">
		<Skeleton
			width="336px"
			height="30px"
		/>
		<div className="list-card">
			{
				Array.from({ length: 5 }, (data, idx) => (
					<div className="card-top-member" key={idx}>
						<Skeleton
							width="40px"
							height="40px"
							borderRadius="50%"
						/>
						<div className="detail">
							<Skeleton
								width="88px"
								height="15px"
								borderRadius="8px"
							/>
							<Skeleton
								width="102px"
								height="15px"
								borderRadius="8px"
							/>
							<Skeleton
								width="117px"
								height="15px"
								borderRadius="8px"
							/>
						</div>
						<Skeleton
							width="102px"
							height="34px"
							borderRadius="4px"
						/>
					</div>
				))
			}
			<div style={{ marginTop: "16px" }}>
				<Skeleton
					width="320px"
					height="20px"
				/>
			</div>
		</div>

		<div style={{ marginTop: "48px" }}>
			<Skeleton
				width="336px"
				height="336px"
			/>
		</div>
		<style jsx>
			{`
        .list-card {
          border: 1px solid #C4CDD5;
          border-radius: 8px;
          padding: 8px;
          margin-top: 16px;
        }

        .card-top-member {
          display: flex;
          gap: 16px;
          background: #FFFFFF;
          box-shadow: inset 0px -1px 0px #DFE3E8;
          padding: 16px 8px 9px 8px;
        }

        .detail {
          width: 130px;
        }
      `}
		</style>
	</div>
);

export default Desktop;
